import React, { useState } from "react";
import { default as ReactSelect, components } from "react-select";

// Options data
const options = [
  { value: "Alginate Mandibular Impression", label: "Alginate Mandibular Impression" },
  { value: "Alginate Maxillary Impression", label: "Alginate Maxillary Impression" },
  { value: "Approved Provisional Model", label: "Approved Provisional Model" },
];

// Custom Option Component with Checkbox
const Option = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: '10px' }}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};

const Enclosure = ({ onSelectionChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Handle selection change
  const handleChange = (selected) => {
    // Initialize count for newly selected options
    const updatedOptions = selected.map((option) => {
      const existingOption = selectedOptions.find((opt) => opt.value === option.value);
      return existingOption ? existingOption : { ...option, count: 1 }; // Default count 1
    });

    setSelectedOptions(updatedOptions);
  };

  // Handle count change
  const handleCountChange = (value, index) => {
    const updatedOptions = [...selectedOptions];
    updatedOptions[index].count = value;
    setSelectedOptions(updatedOptions);
  };

  return (
    <div style={{ width: '100%', fontFamily: 'Arial, sans-serif' }}>
      {/* React Select Dropdown */}
      <ReactSelect
        options={options}
        components={{ Option }}
        isMulti
        onChange={handleChange}
        value={selectedOptions}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        placeholder="Select a component"
        styles={{
          control: (provided) => ({
            ...provided,
            marginBottom: '20px',
            minHeight: '40px',
            width: '100%',
            border: '1px solid #ced4da',
            borderRadius: '4px'
          }),
          menu: (provided) => ({
            ...provided,
            width: '100%'
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
            color: '#6c757d'
          })
        }}
      />

      {/* Selected Items List with Count Input */}
      <div style={{ paddingLeft: '0', lineHeight: '1.6' }}>
        {selectedOptions.map((option, index) => (
          <div key={option.value} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>{index + 1}</span>
            <ul style={{ listStyleType: 'none', paddingLeft: '0', margin: '0', flex: '1' }}>
              <li>{option.label}</li>
            </ul>
            <input
              type="number"
              value={option.count}
              onChange={(e) => handleCountChange(Number(e.target.value), index)}
              style={{
                marginLeft: '10px',
                padding: '8px 8px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                width: '80px',
                fontSize: '12px',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Enclosure;